import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class PersonalParamsService {
  env = environment.env;
  personalConfigurationURL = endpointsURL.personalConfigurationURL;

  constructor(private httpClient: HttpClient) {}

  public getPersonalInfo(idUser: string) {
    let params = new HttpParams().set("_identificador", idUser);

    return this.httpClient.get<any[]>(
      `${this.env}${this.personalConfigurationURL}`,
      {
        params: params,
      }
    );
  }

  public updatePersonalInfo(file: any, personalConfiguration: any) {
    const fd = new FormData();
    if (file == null) {
      fd.append("_certificado", new Blob([], { type: "text/html" }));
    } else {
      fd.append("_certificado", file);
    }
    fd.append(
      "PersonalConfigurationDto",
      JSON.stringify(personalConfiguration)
    );
    return this.httpClient.put<any>(
      `${this.env}${this.personalConfigurationURL}`,
      fd
    );
  }
}
